const playerReport = {
  INDEX: '/player-report',
}

export default playerReport
